const IS_IOS = /i(pad|pod|phone)/i.test(window.navigator.userAgent)

export default IS_IOS
